/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Vue} from 'vue-property-decorator';
import {Route} from 'vue-router/types/router';

/**
 * Navigation hook to provide controlled blur of elements.
 *
 * @param to
 * @param from
 */
export const focusHook: (to: Route, from: Route) => void = (to: Route, from: Route): void => {
    Vue.nextTick(() => {
        (document.activeElement as HTMLElement).blur();
    });
};
